// extracted by mini-css-extract-plugin
export default {"footerBackground":"Footer_footerBackground__TtrCM"};